module.exports = __webpack_public_path__ + "img/danelec-connect_original.d0140787.svg";